import { gql } from '@apollo/client'

export const DROPDOWN_PROCESSING_TYPES_QUERY = gql`
  query dropdownProcessingTypes(
    $sortBy: ProcessingTypeSort
    $filter: ProcessingTypeFilter
    $page: Int
    $limit: Int
  ) {
    processingTypes(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        title
        closeableOnFirstCall
        legalAdviceOnly
        callCenterLegalAdvice
        archived
        accessibleFor
        category
      }
      metadata {
        totalCount
      }
    }
  }
`
